export default commomImport => [{
  path: `meal-finish-order`,
  name: 'mealFinishOrder',
  meta: {
    title: ('store.mealFinish'),
    nameCount: 'prepareds',
    noCache: true
  },
  component: commomImport('order-manager/meal-finish-order')
}];
